module.exports = __webpack_public_path__ + "static/media/www.kulosaarencasino.fi.8b20793d.png";